import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import NavbarHome from '../../../components/ui/NavbarHome';
import PasswordChecker from '../../../components/ui/PasswordChecker';
import { devURL, mailformat, options, titleCase } from '../../../utils';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import GoogleOAuth from '../Google/GoogleOAuth';
import { sendAnalyticsEvent } from '../../../analytics';

const axios = require('axios');

export default function SignUp() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loader, isLoading] = useState(false);
  const [showPasswordChecker, setShowPasswordChecker] = useState(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [country, setCountry] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordCorrections, setPasswordCorrections] = useState({
    isLength: false,
    isUpper: false,
    isLower: false,
    isSymbol: false,
    isNumber: false,
  });

  const defaultReferralCode =
    process.env.REACT_APP_DEPLOY_ENV === 'prod' ? 'SCOPEX23' : 'Milan@123';

  useEffect(() => {
    if (
      localStorage.getItem('swToken') &&
      localStorage.getItem('swToken') != ''
    ) {
      navigate('/Dashboard');
    }
  }, []);

  const passwordVerify = (e) => {
    const lower = /(?=.*[a-z])/;
    const upper = /(?=.*[A-Z])/;
    const length = /(?=.{8,})/;
    const symbol = /(?=.*[!@#$%^&*])/;
    const number = /(?=.*\d)/;

    let pass = e.target.value;
    setPasswordCorrections({
      isLower: lower.test(pass),
      isUpper: upper.test(pass),
      isLength: length.test(pass),
      isSymbol: symbol.test(pass),
      isNumber: number.test(pass),
    });
    console.log('Password:', pass);
    console.log('Contains Lowercase:', lower.test(pass));
    console.log('Contains Uppercase:', upper.test(pass));
    console.log('Meets Length Requirement:', length.test(pass));
    console.log('Contains Symbol:', symbol.test(pass));
    console.log('Contains Number:', number.test(pass));
  };

  const onSubmit = (formValues) => {
    formValues.password = password;
    var passwordformat =
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\!\@\#\$\%\^\&\*\(\)\_\+\.\,\;\:\-]).{8,}/;
    isLoading(true);
    if (formValues.first_name.trim() === '') {
      toast.error('Please enter your first name.');
      isLoading(false);
    } else if (formValues.last_name.trim() === '') {
      toast.error('Please enter your last name.');
      isLoading(false);
    } else if (formValues.username === '') {
      toast.error('Please enter your email address.');
      isLoading(false);
    } else if (!formValues.username.match(mailformat)) {
      toast.error('You have entered an invalid email address!.');
      isLoading(false);
    } else if (formValues.password === '') {
      toast.error('Please enter your password.');
      isLoading(false);
    } else if (formValues.password.length < 8) {
      toast.error('Password should be atleast 8 character.');
      isLoading(false);
    } else if (!formValues.password.match(passwordformat)) {
      toast.error(
        'Password should be must contain at least one number and one uppercase and lowercase letter with at least one special character!.'
      );
      isLoading(false);
    } else if (formValues.repassword === '') {
      toast.error('Please confirm your password.');
      isLoading(false);
    } else if (formValues.password !== formValues.repassword) {
      toast.error('Your entered password is mismatch.');
      isLoading(false);
    } else if (formValues.country === '') {
      toast.error('Please select your country.');
      isLoading(false);
    } else if (!options.includes(formValues.country)) {
      toast.error('Please choose a country from the provided countries');
      isLoading(false);
    } else if (formValues.termcondition === false) {
      toast.error('Please accept terms & conditions.');
      isLoading(false);
    } else {
      formValues.email = formValues.username.toLowerCase();

      axios
        .post(`${devURL}/user/register`, {
          username: formValues.username.toLowerCase(),
          password: formValues.password,
          full_name: `${titleCase(formValues.first_name)} ${titleCase(
            formValues.last_name
          )}`,
          email: formValues.email,
          country: formValues.country,
          referral_code: formValues.referral || defaultReferralCode,
        })
        .then((res) => {
          isLoading(false);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'You have successfully registred!',
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(res);
          //toast("You have successfully registred!");
          sendAnalyticsEvent('sign_up', {
            category: 'user',
            action: 'sign_up',
            label: 'user_sign_up',
          });
          navigate('/Login');
        })
        .catch((err) => {
          isLoading(false);
          if (
            err.response &&
            err.response.data &&
            err.response.data.errorMessage
          ) {
            toast.error(err.response.data.errorMessage);
          }
        });
    }
  };

  const handleChange = (event) => {
    setCountry(event.target.value);
  };
  const handleCase = (event) => {
    setCountry(
      event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
    );
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='h-screen flex flex-col overflow-x-hidden font-nunito'>
        <div className=''>
          <NavbarHome />
        </div>
        <div className=' grid grid-cols-12 mt-14 justify-items-center justify-center flex-1 items-center py-8'>
          <div className='md:col-start-3 md:col-end-11 lg:col-start-4 lg:col-end-10 col-start-2 col-end-12 w-full px-8 mt-4  bg-white py-8 shadow-lg rounded-xl border-2'>
            <h1 className='text-center text-3xl font-extrabold text-gray-900 pb-4'>
              Sign up
            </h1>

            <div className='grid gap-3 text-base'>
              <div>
                <label htmlFor='first_name' className='font-medium'>
                  First name<span style={{ color: 'red' }}>*</span> (as per documents)
                </label>
                <input
                  onKeyPress={(event) => {
                    if (!/^[A-Za-z ]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  {...register('first_name', { required: true })}
                  style={errors.first_name ? { border_color: 'red' } : {}}
                  name='first_name'
                  className='appearance-none text-sm rounded-none font-medium relative block w-full px-5 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md :outline-none :ring-indigo-500 :border-indigo-500 :z-10 mt-2'
                  placeholder='John'
                />
              </div>
              <div>
                <label htmlFor='last_name' className='font-medium'>
                  Last name<span style={{ color: 'red' }}>*</span> (as per documents)
                </label>
                <input
                  onKeyPress={(event) => {
                    if (!/^[A-Za-z ]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  {...register('last_name', { required: true })}
                  name='last_name'
                  className='appearance-none text-sm rounded-none font-medium relative block w-full px-5 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md :outline-none :ring-indigo-500 :border-indigo-500 :z-10 mt-2'
                  placeholder='Doe'
                />
              </div>

              <div>
                <label htmlFor='username' className='font-medium'>
                  Email address<span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  {...register('username', { required: true })}
                  style={errors.username ? { border_color: 'red' } : {}}
                  name='username'
                  type='email'
                  className='appearance-none text-sm rounded-none font-medium relative block w-full px-5 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md :outline-none :ring-indigo-500 :border-indigo-500 :z-10 mt-2'
                  placeholder='johndoe@example.com'
                />
              </div>
              <div>
                <label htmlFor='Country' className='font-medium'>
                  Country of residence<span style={{ color: 'red' }}>*</span>
                </label>
                <div>
                  <input
                    {...register('country', { required: true })}
                    style={errors.country ? { border_color: 'red' } : {}}
                    list='list'
                    type='country'
                    placeholder='Enter the country'
                    data-test='country'
                    value={country}
                    className='appearance-none text-sm rounded-none font-medium relative block w-full px-5 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md :outline-none :ring-indigo-500 :border-indigo-500 :z-10 mt-2'
                    onChange={handleChange}
                    onInputCapture={handleCase}
                  ></input>
                </div>
                <datalist id='list' name='country'>
                  <option
                    className='px-5 py-3 text-lg'
                    value='India'
                    data-test='data-list'
                  ></option>
                  <option className='px-5 py-3 text-lg' value='Nepal'></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Austria'
                  ></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Belgium'
                  ></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Croatia'
                  ></option>
                  <option className='px-5 py-3 text-lg' value='Cyprus'></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Estonia'
                  ></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Finland'
                  ></option>
                  <option className='px-5 py-3 text-lg' value='France'></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Germany'
                  ></option>
                  <option className='px-5 py-3 text-lg' value='Greece'></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Ireland'
                  ></option>
                  <option className='px-5 py-3 text-lg' value='Italy'></option>
                  <option className='px-5 py-3 text-lg' value='Latvia'></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Lithuania'
                  ></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Luxembourg'
                  ></option>
                  <option className='px-5 py-3 text-lg' value='Malta'></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Netherlands'
                  ></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Portugal'
                  ></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Slovakia'
                  ></option>
                  <option
                    className='px-5 py-3 text-lg'
                    value='Slovenia'
                  ></option>
                  <option className='px-5 py-3 text-lg' value='Spain'></option>
                </datalist>
              </div>
              <div className='relative'>
                <label htmlFor='password' className='font-medium relative'>
                  Password<span style={{ color: 'red' }}>*</span>
                </label>
                <div className='relative flex items-center'>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name='password'
                    autoComplete='new-password'
                    className='appearance-none text-sm rounded-none font-medium relative block w-full px-5 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md :outline-none :ring-indigo-500 :border-indigo-500 :z-10 mt-2'
                    placeholder='Password'
                    onClick={() => {
                      setShowPasswordChecker(true);
                    }}
                    onBlur={() => setShowPasswordChecker(false)}
                    onChange={(e) => {
                      passwordVerify(e);
                      setPassword(e.target.value);
                    }}
                  />
                  <button
                    className='absolute left-full -translate-x-full p-2 z-20 mt-2'
                    onClick={(e) => {
                      e.preventDefault();
                      setShowPassword((val) => !val);
                    }}
                    data-test='show-password'
                  >
                    {!showPassword ? (
                      <AiOutlineEye size='1.2rem' />
                    ) : (
                      <AiOutlineEyeInvisible size='1.2rem' />
                    )}
                  </button>
                </div>
                <div
                  className={`w-max block lg:aboslute z-10 inset-x-full top-1/3 p-1 rounded bg-slate-50 drop-shadow-lg ml-4 ${
                    showPasswordChecker ? 'block' : 'hidden'
                  }`}
                >
                  <PasswordChecker {...passwordCorrections} />
                </div>
              </div>
              <div>
                <label htmlFor='confirmpassword' className='font-medium'>
                  Confirm password<span style={{ color: 'red' }}>*</span>
                </label>
                <div className='relative flex items-center'>
                  <input
                    {...register('repassword', { required: true })}
                    style={errors.repassword ? { border_color: 'red' } : {}}
                    type={showConfirmPassword ? 'text' : 'password'}
                    name='repassword'
                    autoComplete='new-password'
                    className='appearance-none rounded-none text-sm font-medium relative block w-full px-5 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md :outline-none :ring-indigo-500 :border-indigo-500 :z-10 mt-2'
                    placeholder='Confirm Password'
                  />
                  <button
                    className='absolute left-full -translate-x-full p-2 z-20 mt-2'
                    onClick={(e) => {
                      e.preventDefault();
                      setShowConfirmPassword((val) => !val);
                    }}
                    data-test='show-repassword'
                  >
                    {!showConfirmPassword ? (
                      <AiOutlineEye size='1.2rem' />
                    ) : (
                      <AiOutlineEyeInvisible size='1.2rem' />
                    )}
                  </button>
                </div>
              </div>
              <div>
                <label htmlFor='referralcode' className='font-medium'>
                  Referral code
                </label>
                <input
                  {...register('referral', { required: false })}
                  style={errors.referral ? { border_color: 'red' } : {}}
                  type='text'
                  name='referral'
                  className='appearance-none rounded-none text-sm font-medium relative block w-full px-5 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md :outline-none :ring-indigo-500 :border-indigo-500 :z-10 mt-2'
                  placeholder='Enter referral code or SCOPEX23'
                />
              </div>
              <div className='flex items-center gap-2 mt-2 '>
                <input
                  {...register('termcondition')}
                  name='termcondition'
                  type='checkbox'
                  value=''
                  className='h-4 w-4 text-indigo-600 :ring-indigo-500 border-gray-300 rounded'
                />
                <label
                  htmlFor='rememberme'
                  className='text-center text-sm text-grey-dark'
                >
                  By signing up, you agree to the{' '}
                  <Link to='/terms-and-conditions' className='text-blue-600'>
                    <u>Terms of service and Privacy policy</u>
                  </Link>
                  <span style={{ color: 'red' }}>*</span>
                </label>
              </div>
              <div className='flex flex-col gap-2'>
                <button
                  type='submit'
                  className='w-full mt-2 text-center py-2  rounded bg-green text-white :outline-none my-1 bg-themeColor hover:bg-themeHover'
                  // style={{ backgroundColor: "#5c6e64" }}
                  style={{ backgroundColor: '#246eaa' }}
                >
                  {loader && (
                    <svg
                      role='status'
                      className='inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600'
                      viewBox='0 0 100 101'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                        fill='currentColor'
                      />
                      <path
                        d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                        fill='currentFill'
                      />
                    </svg>
                  )}
                  {!loader && <>Create Account</>}
                </button>
                <div className='self-center font-bold'>or</div>
                <GoogleOAuth />
              </div>
            </div>
            <div className='text-grey-dark text-center mt-6 border-t-2 border-solid border-gray-300'>
              <div className='mt-4 text-lg'>
                Already have an account? &nbsp;
                <span style={{ color: '#246eaa' }}>
                  <Link to='/Login' className='font-extrabold ml-1 text-md'>
                    <u>Log in</u>
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
